module.exports = __webpack_public_path__ + "assets/add.b0e4788e.svg";